import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'bc-global-notification',
  templateUrl: './global-notification.component.html',
  styleUrls: ['./global-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GlobalNotificationComponent {
  private _message: string;

  @Input()
  set message(value: string) {
    this._message = value;
    const c = this.cookieService.get('dismissed-global-notification');
    if (c === value) {
      this.dismissed = true;
    }
  }
  get message(): string {
    return this._message;
  }

  private dismissed = false;

  constructor(private readonly cookieService: CookieService) {}

  dismiss(): void {
    this.cookieService.set('dismissed-global-notification', this.message);
    this.dismissed = true;
  }

  show(): boolean {
    return this.message && !this.dismissed;
  }
}
